// @flow

import { getAppliedFacetsCount } from './get-applied-facets-count';
import getOrderedFacetsFromUrl from './get-ordered-facets-from-url';

type MediatorProps = {
  isDesktop: Boolean,
  facets: any,
  enabledFeatures: EnabledFeatures,
  market: Market,
  abbrBrand: AbbrBrand,
  abSeg: any,
};

const isDepartmentAnOption = (facetOptions = []) => {
  if (!Array.isArray(facetOptions)) return false;

  const departmentFacet = facetOptions.find(
    (facet) => facet.name === 'department'
  );

  return Boolean(departmentFacet);
};

const shouldHideDeparmentFacet = (facets, hideDepartamentFlag) => {
  if (hideDepartamentFlag) {
    facets.facetOptions = facets.facetOptions.filter(
      (facet) => facet.name !== 'department'
    );
  }
};

const applyPreviousState = (facets, prevstate) => {
  const checkForField = ['storeId', 'sortByField', 'sortByDir'];

  checkForField.forEach((field) => {
    if (prevstate?.facets?.appliedFacets?.[field]) {
      facets.appliedFacets[field] = prevstate.facets.appliedFacets[field];
    }
  });
};

const updateFacetData = (
  props: MediatorProps,
  prevstate: any,
  data: ProductData,
  totalItemCount: number,
  facetQueryString: string
) => {
  const facets = data.facetData;
  const { market, abbrBrand } = props;

  shouldHideDeparmentFacet(
    facets,
    props?.enabledFeatures[`department-facet-hide-${market}-${abbrBrand}`]
  );
  facets.appliedFacets = facets.appliedFacets || {};
  applyPreviousState(facets, prevstate);

  if (totalItemCount === 0) {
    facets.appliedFacets = prevstate.facets.appliedFacets;
  }

  const orderedFacets = getOrderedFacetsFromUrl(
    facets.appliedFacets,
    facetQueryString
  );

  return {
    appliedFacetsCount: getAppliedFacetsCount(
      facets.appliedFacets,
      prevstate.ignoredFacets
    ),
    disablePlaceholders: true,
    facets,
    isDepartmentAnOption: isDepartmentAnOption(facets.facetOptions),
    paginator: data.paginator,
    productGroups: data.gridData,
    totalItemCount,
    facetQueryString,
    orderedFacets,
  };
};

export { updateFacetData };
